import { PDFViewer } from "@react-pdf/renderer";

export default function ModaleFacture2({ register, errors = {}, pdfDocument }) {
  return (
    <div className="flex gap-12 mt-8 px-12 pb-16 h-full">
      {/* Colonne gauche : formulaire */}
      <div className="flex flex-col gap-6 w-1/2">
        <div className="flex w-full gap-12">
          <div className="w-full">
            <p className="form-label text-md mb-2">Nom</p>
            <input
              type="text"
              className={`form-input w-full ${errors.last_name ? 'has-error' : ''}`}
              {...register('last_name')}
            />
            {errors.last_name && <p className="text-red-600 text-sm mt-1 font-semibold">{errors.last_name.message}</p>}
          </div>
          <div className="w-full">
            <p className="form-label text-md mb-2">Prénom</p>
            <input
              type="text"
              className={`form-input w-full ${errors.first_name ? 'has-error' : ''}`}
              {...register('first_name')}
            />
            {errors.first_name && <p className="text-red-600 text-sm mt-1 font-semibold">{errors.first_name.message}</p>}
          </div>
        </div>

        <div>
          <p className="form-label text-md mb-2">Adresse e-mail</p>
          <input
            type="email"
            className={`form-input w-full ${errors.email ? 'has-error' : ''}`}
            {...register('email')}
          />
          {errors.email && <p className="text-red-600 text-sm mt-1 font-semibold">{errors.email.message}</p>}
        </div>

        <div>
          <p className="form-label text-md mb-2">Objet</p>
          <input
            type="text"
            className={`form-input w-full ${errors.subject ? 'has-error' : ''}`}
            {...register('subject')}
          />
          {errors.subject && <p className="text-red-600 text-sm mt-1 font-semibold">{errors.subject.message}</p>}
        </div>

        <div className="form-input-container items-center mt-6 flex-1 flex flex-col">
          <p className="form-label text-md mb-2 w-full">Message du mail</p>
          <textarea
            className={`form-input w-full flex-1 ${errors.body ? 'has-error' : ''}`}
            {...register('body')}
          />
          {errors.body && <p className="text-red-600 text-sm mt-1 font-semibold">{errors.body.message}</p>}
        </div>
      </div>

      {/* Colonne droite : aperçu PDF */}
      <div className="w-1/2 flex flex-col">
        <p className="form-label text-md mb-2">Aperçu du justificatif</p>
        <div className="flex-1 border border-zinc-300 rounded overflow-hidden" style={{ minHeight: '500px' }}>
          {pdfDocument ? (
            <PDFViewer width="100%" height="100%" showToolbar={false} style={{ border: 'none' }}>
              {pdfDocument}
            </PDFViewer>
          ) : (
            <div className="flex items-center justify-center h-full text-zinc-400">
              Chargement de l'aperçu...
            </div>
          )}
        </div>
      </div>
    </div>
  )
}